module.exports = __webpack_public_path__ + "img/advantage2_1@2x.b55ec2c8.png";